/* Pre-order acknowledgement gate for the cart drawer + cart page.
   Markup: snippets/wickii-preorder-cart-ack.liquid. Listeners are delegated to
   document so they survive the drawer's innerHTML re-renders. */
(function () {
  'use strict';
  var MSG = 'Please tick the pre-order box before checking out.';
  var ATTR_VALUE = 'Yes';

  function boxes() { return document.querySelectorAll('[data-wf-po-ack]'); }
  function firstUnticked() {
    var b = boxes();
    for (var i = 0; i < b.length; i++) { if (!b[i].checked) return b[i]; }
    return null;
  }
  function syncExpress() {
    var hide = !!firstUnticked();
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.style.display = hide ? 'none' : '';
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-wf-po-ack]')) return;
    t.setCustomValidity('');
    var val = t.checked ? ATTR_VALUE : '';
    boxes().forEach(function (b) { b.checked = t.checked; });
    document.querySelectorAll('[data-wf-po-attr]').forEach(function (i) { i.value = val; });
    syncExpress();
    var url = (window.theme && theme.routes && theme.routes.cart_update_url) ? theme.routes.cart_update_url : '/cart/update';
    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Pre-order acknowledged': val } })
    }).catch(function () {});
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('button[name="checkout"], .checkout-button');
    if (!btn) return;
    var unticked = firstUnticked();
    if (!unticked) return;
    e.preventDefault();
    e.stopPropagation();
    // Prefer the copy of the box sitting next to the button that was clicked,
    // so the validity bubble appears on a visible element.
    var container = btn.closest('.cart-drawer') || btn.closest('.thb-cart-collaterals') || document;
    var target = container.querySelector('[data-wf-po-ack]') || unticked;
    if (target.checked) target = unticked;
    target.setCustomValidity(MSG);
    if (target.reportValidity) target.reportValidity();
    var wrap = target.closest('[data-wf-po-ack-wrap]');
    if (wrap) {
      wrap.classList.add('wf-po-attention');
      setTimeout(function () { wrap.classList.remove('wf-po-attention'); }, 1500);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', syncExpress);
  ['cart-drawer:open', 'line-item:change:end', 'cart:item-added', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, syncExpress);
  });
})();
